// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uEmz","newExpiryDate":"styles_newExpiryDate__30a0v","footer":"styles_footer__1SrWj"};